import React, { useContext } from 'react';
import { useQuery } from 'react-apollo';
import { BasePage, Helmet, StaticContext, SurveyTheme, FourOhFourErrorPage } from '@sm/webassets';
import { Container } from '@sm/wds-react';
import { t } from '@sm/intl';
import { Header, EnterpriseThankYouBody, EnterpriseThankYouFooter, BackgroundThemeWrapper } from './components';
import { getDefaultEndPageSettings } from './EnterpriseThankYou.graphql';
import COPY from './copy';
import './enterprise-thank-you.scss';

const EnterpriseThankYou = () => {
  const { sm } = useContext(StaticContext);
  const smSlug = sm?.smStr || '';
  const ownerId = sm?.smParams?.owner_id || '';
  const surveyId = sm?.smParams?.survey_id || '';
  const hasPremium = sm?.smParams?.has_premium.toLowerCase() === 'true';
  const hasStandard = sm?.smParams?.has_standard.toLowerCase() === 'true';

  // In the case we need to us lo-server to make our calls, we might also need
  // to use the survey owner user id to authorize the calls for us to get the
  // correct information.
  const thankYouHeaders = {
    'X-Owner-ID': ownerId,
  };

  const {
    loading: loadingThankYou,
    error: errorThankYou,
    data: endPageSettings,
  } = useQuery(getDefaultEndPageSettings, {
    variables: {
      smSlug,
    },
    context: {
      targetPath: '/lo-graphql/enterpriseThankYou',
      headers: thankYouHeaders,
    },
  });

  if (errorThankYou || (!loadingThankYou && endPageSettings == null)) {
    return <FourOhFourErrorPage />;
  }

  if (endPageSettings) {
    const endPageIsEnabled = endPageSettings?.defaultEndPageSettings?.isEnabled;
    const headerLogoUrl = endPageSettings?.defaultEndPageSettings?.logo?.url;
    const headerText = endPageSettings?.defaultEndPageSettings?.thankYouText;
    const bodyImageUrl = endPageSettings?.defaultEndPageSettings?.image?.url;
    const bodyText = endPageSettings?.defaultEndPageSettings?.bodyText;
    const bodyImageRedirectUrl = endPageSettings?.defaultEndPageSettings?.imageRedirectUrl;

    return (
      <BasePage
        actionFlow="EnterpriseThankYou"
        pageId="EnterpriseThankYou"
        legacyWeb="respweb"
        includeHeader={false}
        includeFooter={false}
      >
        <Helmet>
          <base target="_top" href="/" />
          <title>{t(COPY.THANK_YOU)}</title>
          <meta name="description" content={t(COPY.THANK_YOU)} />
        </Helmet>
        <SurveyTheme surveyId={surveyId} targetEndPoint="enterpriseThankYou" headers={thankYouHeaders}>
          <BackgroundThemeWrapper>
            <Container
              className="sm-enterprise-thank-you__outline"
              flexJustify="center"
              py={8}
              data-testid="EnterpriseThankYouV2__OutlineContainer"
            >
              <Container className="sm-enterprise-thank-you__content-outline">
                <Header
                  premium={hasPremium}
                  headerLogoUrl={headerLogoUrl}
                  headerText={headerText}
                  endPageIsEnabled={endPageIsEnabled}
                />
                <EnterpriseThankYouBody
                  premium={hasPremium}
                  bodyImageUrl={bodyImageUrl}
                  bodyText={bodyText}
                  bodyImageRedirectUrl={bodyImageRedirectUrl}
                  endPageIsEnabled={endPageIsEnabled}
                />
              </Container>
              <EnterpriseThankYouFooter premium={hasPremium} standard={hasStandard} />
            </Container>
          </BackgroundThemeWrapper>
        </SurveyTheme>
      </BasePage>
    );
  }
  return null;
};

export default EnterpriseThankYou;
